import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ListService, TrackByService } from '@abp/ng.core';

import { finalize, tap } from 'rxjs/operators';
import type { GalileuCredentialWithNavigationPropertiesDto } from '../../../proxy/galileu-credentials/models';
import { GalileuCredentialService } from '../../../proxy/galileu-credentials/galileu-credential.service';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';

@Injectable()
export class GalileuCredentialDetailViewService {
  protected readonly fb = inject(FormBuilder);
  protected readonly track = inject(TrackByService);
  protected readonly confirmationService = inject(ConfirmationService);

  private readonly options: Partial<Confirmation.Options> = {
    hideCancelBtn: true,
    hideYesBtn: false,
    dismissible: true,
    yesText: "Fechar",
  };



  public readonly proxyService = inject(GalileuCredentialService);
  public readonly list = inject(ListService);

  public readonly getIdentityUserLookup = this.proxyService.getIdentityUserLookup;

  isBusy = false;
  isVisible = false;
  selected = {} as any;
  form: FormGroup | undefined;

  protected createRequest() {
    const formValues = {
      ...this.form.value,
    };

    if (this.selected) {
      return this.proxyService.update(this.selected.galileuCredential.id, {
        ...formValues,
        concurrencyStamp: this.selected.galileuCredential.concurrencyStamp,
      });
    }

    return this.proxyService.create(formValues);
  }

  buildForm() {
    const { login, senha, identityUserId } = this.selected?.galileuCredential || {};

    this.form = this.fb.group({
      login: [login ?? null, [Validators.required]],
      senha: [null, [Validators.required]],
      identityUserId: [identityUserId ?? null, [Validators.required]],
    });
  }

  showForm() {
    this.buildForm();
    this.isVisible = true;
  }

  create() {
    this.selected = undefined;
    this.showForm();
  }

  update(record: GalileuCredentialWithNavigationPropertiesDto) {
    this.selected = record;
    this.showForm();
  }

  hideForm() {
    this.isVisible = false;
  }

  submitForm() {
    if (this.form.invalid) return;

    this.isBusy = true;

    const request = this.createRequest().pipe(
      finalize(() => (this.isBusy = false)),
      tap((result) => {
        this.proxyService.getWithNavigationProperties(result.id).subscribe((updated: GalileuCredentialWithNavigationPropertiesDto) => {
          // Atualiza o selected com o item completo
          this.selected = updated;

          this.form.patchValue({
            senha: null
          }, {emitEvent: false})

          // Exibe a mensagem de sucesso
          this.confirmationService.success("Dados do Galileu sincronizados com sucesso!","Sincronização", this.options)
        });        // Display success message
      }),

    );

    request.subscribe(this.list.get);
  }

  changeVisible($event: boolean) {
    this.isVisible = $event;
  }
}
